module.exports = __webpack_public_path__ + "img/playV1.16e36027.png";